import { IconKey } from '../../icon-key.enum';

export default {
  [IconKey.SidebarDashboard]: 'fa-fw fa-solid fa-sharp fa-house',
  [IconKey.SidebarMyFleet]: 'fa-fw fa-solid fa-sharp fa-excavator',
  [IconKey.SidebarFleetOverview]: 'fa-fw fa-solid fa-sharp fa-arrow-up-right-from-square',
  [IconKey.SidebarMaintenanceAndInspections]: 'fa-fw fa-solid fa-sharp fa-briefcase',
  [IconKey.SidebarMaintenanceAndInspectionsUpcoming]: 'fa-fw fa solid fa-sharp fa-wrench',
  [IconKey.SidebarMaintenanceAndInspectionsHistory]: 'fa-fw fa solid fa-sharp fa-history',
  [IconKey.SidebarReporting]: 'fa-fw fa solid fa-sharp fa-chart-bar',
  [IconKey.SidebarReportingAvailable]: 'fa-fw fa solid fa-sharp fa-square-poll-vertical',
  [IconKey.SidebarReportingAutomatic]: 'fa-fw fa solid fa-sharp fa-rotate-right',
  [IconKey.SidebarNotifications]: 'fa-fw fa-solid fa-light-emergency-on',
  [IconKey.SidebarExpand]: 'fa solid fa-sharp fa-thumbtack-slash fa-fw',
  [IconKey.SidebarCollapse]: 'fa solid fa-sharp fa-thumbtack fa-fw',
  [IconKey.SidebarAdministration]: 'fa solid fa-sharp fa-gear fa-fw',
  [IconKey.SidebarAdministrationMaintenanceAndInspections]: 'fa-solid fa-solid fa-list-ol fa-fw',

  [IconKey.TopbarAttentionIndicator]: 'fa-fw fa solid fa-circle-exclamation',
  [IconKey.TopbarNotificationIndicator]: 'fa-fw fa-kit fa-bell2',
  [IconKey.TopbarNotificationAcknowledge]: 'fa-fw fa-solid fa-circle-check',
  [IconKey.TopbarInfo]: 'fa-fw fa-kit fa-wn-question-mark',
  [IconKey.TopbarAppSwitcher]: 'fa-fw fa-kit fa-wn-app-switcher',
  [IconKey.TopbarUserSwitcherAvatar]: 'fa-fw fa solid fa-sharp fa-user',
  [IconKey.TopbarUserSwitcherDropdown]: 'fa-fw fa solid fa-sharp fa-chevron-down',

  [IconKey.FilterSelector]: 'fa-fw fa-solid fa-sliders',
  [IconKey.MapLayerEquipment]: 'fa-regular fa-fw fa-sharp fa-excavator',
  [IconKey.MaintenanceCategoryReminder]: 'fa-regular fa-fw fa-list',
};
